export interface AccountingConnectionRequest {
  provider: AccountingProviderCompany | undefined;
}

export interface AccountConnectionDetail extends AccountingConnectionRequest {
  status: AccountingConnectionStatus;
  bank_accounts_created: boolean; // PAYS created on Provider. True for new connections
  source_account: AccountingAccount;
  tenant: TenantAccountOption;
  sync_enabled: boolean;
}

export interface AccountingConnection {
  url: string;
}

export interface AccountingProvider {
  name: AccountingProviderCompany;
  connected: boolean;
}

export interface AccountingAccount {
  id: number;
  type: string;
  name: string;
  code: string;
  description: string;
}

export interface AccountOptionBase {
  id: number;
  type: string;
  display_name?: string; // FE only for display purposes
}

export interface TenantAccountOption extends AccountOptionBase {
  type: string;
  name?: string;
}

export interface AccountingContact {
  id: number | null;
  name?: string;
}

export enum AccountingContactMatch {
  FUZZY = 1,
  EXACT = 2,
  OTHER = 3,
  OK = 10,
}

export interface AccountingSync {
  status: AccountingSyncStatus;
}

export interface AccountingTrackingCategory {
  id: number;
  name: string;
  options: TrackingCategoryOption[];
}

export interface TrackingCategoryOption {
  id: number;
  name: string;
}

export interface AccountingTaxRates {
  id: number;
  code: string;
  name: string;
  rate: string;
}

export enum AccountingProviderCompany {
  XERO = 'Xero',
  QUICKBOOKS = 'Quickbooks',
  SAGE = 'Sage',
  ZOHO = 'Zoho',
}

export enum AccountingConnectionStatus {
  Pending = 'Pending',
  HasToken = 'HasToken',
  HasTenants = 'HasTenants',
  HasAccounts = 'HasAccounts',
  Complete = 'Complete',
  Disconnected = 'Disconnected',
  Error = 'Error', // setup fail, e.g. error creating bank accounts
  HttpError = 'HttpError',
  AuthError = 'AuthError', // daily token refresh fail
}

export enum AccountingSyncStatus {
  New = 0,
  Busy = 1,
  Fail = 2,
  Done = 10,
}

export enum AccountingAccountType {
  Expense = 1,
  Contra = 10,
  Bank = 20,
}

export enum AccountingSyncType {
  Transactions = 1,
  Accounts = 2,
  Contacts = 3,
}
